import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_LIST_BANK = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetBankList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Banks {
        data {
          id
          account_name
          account_number
          name
          address
          swift_code
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;
